import { ANNOUNCEMENT_ACTIONS as type } from "@common/constants/actionTypes";

// Intentionally no isFetching flag — the announcement banner has no loading spinner.
const initialState = { items: [], lastError: "" };

export default function announcementsReducer(state = initialState, action) {
  switch (action.type) {
    case type.GET_ANNOUNCEMENTS:
      return Object.assign({}, state, { lastError: "" });
    case type.GET_ANNOUNCEMENTS_SUCCESS:
      return Object.assign({}, state, { items: action.items, lastError: "" });
    case type.GET_ANNOUNCEMENTS_ERROR:
      return Object.assign({}, state, { lastError: action.message });
    default:
      return state;
  }
}
